import { LucideIcon } from 'lucide-react'
import clsx from 'clsx'

interface MetricCardProps {
  title: string
  value: string
  icon: LucideIcon
  variant?: 'positive' | 'negative' | 'neutral'
  subtitle?: string
}

export default function MetricCard({
  title,
  value,
  icon: Icon,
  variant = 'neutral',
  subtitle,
}: MetricCardProps) {
  return (
    <div className="card">
      <div className="flex items-start justify-between">
        <div>
          <p className="metric-label">{title}</p>
          <p className={clsx('metric-value mt-1', variant)}>{value}</p>
          {subtitle && (
            <p className="text-xs text-[#666] mt-1">{subtitle}</p>
          )}
        </div>
        <div className={clsx(
          'w-10 h-10 rounded-lg flex items-center justify-center',
          variant === 'positive' && 'bg-green-500/10 text-green-400',
          variant === 'negative' && 'bg-red-500/10 text-red-400',
          variant === 'neutral' && 'bg-blue-500/10 text-blue-400'
        )}>
          <Icon size={20} />
        </div>
      </div>
    </div>
  )
}
